function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M21.2 0H2.8C1.2 0 0 1.2 0 2.7v.6c0 1.5 1.2 2.8 2.8 2.8h18.4c1.5 0 2.8-1.2 2.8-2.8v-.6C24 1.2 22.8 0 21.2 0z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 7,
    viewBox: "0 0 24 7"
  }, props), _ref);
};

export default SvgComponent;